import {http, onSuccess, onFail} from "./http";

export const registerOrganizationUser = (accessToken, data) =>
    http.post(`/api/cp/login/registration`, {accessToken, ...data})
        .then(onSuccess, onFail);

export const getLogin = () =>
    http.get(`/api/cp/login`)
        .then(onSuccess, onFail);

export const requestLoginPassword = (email) =>
    http.post(`/api/cp/login/requestPassword`, {email})
        .then(onSuccess, onFail);

export const login = (email, password) =>
    http.post(`/api/cp/login`, {email, password})
        .then(onSuccess, onFail);

export const logout = () =>
    http.post(`/api/cp/logout`)
        .then(onSuccess, onFail);
